const deviceType = {
  isPC: null,
  isMobile: null,
  isPad: null
}

function getDeviceType () {
  try {
    document.createEvent('TouchEvent')
    if (navigator.userAgent.match(/Tablet|iPad/i)) {
      deviceType.isPad = true
      deviceType.isMobile = false
      deviceType.isPC = false
    } else if (navigator.userAgent.match(/Mobile|Windows Phone|Lumia|Android|webOS|iPhone|iPod|Blackberry|PlayBook|BB10|Opera Mini|\bCrMo\/|Opera Mobi/i)) {
      deviceType.isMobile = true
      deviceType.isPad = false
      deviceType.isPC = false
    }
  } catch (e) {
    deviceType.isPC = true
    deviceType.isMobile = false
    deviceType.isPad = false
  }
}

getDeviceType()

export default { ...deviceType }



// WEBPACK FOOTER //
// ./src/utils/deviceType.js